<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmarRealinhar"
			nome-botao-confirmar="Realinhar"
			:is-confirmar-visivel="isConfirmarVisivel"
			:is-confirmar-desabilitado="isConfirmarDesabilitado"
			:tamanho="modalOptions"
			@close="fecharModal"
		>
			<template #body>
				<div class="my-1" :class="{ ajustar_altura_do_modal_com_historico: !$vuetify.breakpoint.mobile }">
					<painel-com-tabs-sem-rotas :tabs="tabs" @tab-atual="botaoRealinharNaoDeveAparecerNaAbaHistorico">
						<template #realinhar>
							<realinhamento-realinhar :item-selecionado="itemSelecionado"></realinhamento-realinhar>
						</template>
						<template #historico>
							<div class="mt-2">
								<historico-realinhar :item-selecionado="itemSelecionado"></historico-realinhar>
							</div>
						</template>
						<template #acoes-tabs>
							<botao-gerar-pdf-historico
								:tipo-historico="tipoHistorico.HISTORICO_REALINHAMENTO"
								:id-entidade="itemSelecionado.id"
								v-if="!isConfirmarVisivel"
							></botao-gerar-pdf-historico>
						</template>
					</painel-com-tabs-sem-rotas>
				</div>
			</template>
		</modal>
	</v-form>
</template>

<script>
import { TabSemRotaUtils } from '@/core/utils'
import HistoricoRealinhar from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/realinhar/historico/HistoricoRealinhar.vue'
import RealinhamentoRealinhar from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/realinhar/realinhamento/Realinhamento.vue'
import { mapState } from 'vuex'
import validacaoAta from '@/views/mixins/validacaoAta'
import { getterTypes } from '@/core/constants'
import tipoHistorico from '@/core/constants/tipo-historico'
import BotaoGerarPdfHistorico from '@/views/components/botoes/gerar-pdf-historico/BotaoGerarPdfHistorico.vue'

export default {
	name: 'modal-realinhar',
	components: { BotaoGerarPdfHistorico, RealinhamentoRealinhar, HistoricoRealinhar },
	mixins: [validacaoAta],
	props: {
		exibir: {
			type: Boolean,
		},
		itemSelecionado: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			tabs: [
				new TabSemRotaUtils(1, 'Realinhamento', 'realinhar', () => this.temPermissaoEdicao),
				new TabSemRotaUtils(2, 'Histórico', 'historico', this.existeHistorico),
			],
			tituloModal: 'Realinhar',
			modalOptions: {
				largura: '900',
				altura: '500',
			},
			formIsValid: true,
			isConfirmarVisivel: false,
		}
	},
	computed: {
		tipoHistorico() {
			return tipoHistorico
		},
		isConfirmarDesabilitado() {
			return !this.formIsValid
		},
		...mapState({
			realinhar: (state) => state.itemAta.realinhamento.realinhar,
		}),
	},

	methods: {
		botaoRealinharNaoDeveAparecerNaAbaHistorico(tabValue) {
			const naoEhHistorico = tabValue !== 1

			if (this.temPermissaoEdicao) {
				this.isConfirmarVisivel = naoEhHistorico
			} else {
				this.isConfirmarVisivel = !naoEhHistorico
			}
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		confirmarRealinhar() {
			if (this.$refs.form.validate()) {
				if (this.validarSeNaoPossuiNovoValor() && this.validarSeNaoPossuiNovaMarca()) {
					this.mostrarNotificacaoErro('Não há informação de valor ou marca preenchida.')
					return
				}

				this.$emit('salvar-realinhar', this.formIsValid)
			}
		},
		validarSeNaoPossuiNovaMarca() {
			return !this.realinhar.novaMarca || this.realinhar.novaMarca.trim().length === 0
		},
		validarSeNaoPossuiNovoValor() {
			return this.realinhar.novoValor === null
		},
		existeHistorico() {
			return this.$store.getters[getterTypes.ITEM_ATA.EXISTE_HISTORICO_REALINHAMENTO]
		},
	},
}
</script>

<style lang="stylus" scoped></style>
